import { InstallmentFeesFields } from '@/components/InstallmentFeesFields';
/* eslint-disable import/no-unresolved */
import { InputText } from '@/components';
import { updateMask } from '@/helpers/masks/cashNumber';
import React, { Fragment } from 'react';
import { Col, Form, FormGroup, Row } from 'reactstrap';

// eslint-disable-next-line no-shadow
export enum States {
  default = 'default',
  loading = 'loading',
}

// eslint-disable-next-line no-shadow
export enum FormInputName {
  physicalSaleDebit = 'physicalSaleDebit',
  physicalSaleCredit = 'physicalSaleCredit',
  physicalSalePix = 'physicalSalePix',
  physicalSaleAdministrateTax = 'physicalSaleAdministrateTax',
  physicalSaleInstallmentFees = 'physicalSaleInstallmentFees',
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const PdvConfigContent: React.FC<any> = ({ formPdvConfig }) => {
  const { formData, onChangeFormInput, formErrors } = formPdvConfig;

  return (
    <Fragment>
      <Form
        noValidate={true}
        onSubmit={(e): void => {
          e.preventDefault();
        }}
      >
        <Row>
          <Col md={8}>
            <div className="container-event mb-4">
              <h5 className="mb-2 border-bottom-title mb-5">Taxas de cartão</h5>
            </div>
            <p style={{ fontSize: '21px', fontWeight: '500' }}>Venda física</p>

            <FormGroup>
              <InputText
                name="physicalSaleDebit"
                label="Débito"
                className="w-input-sm"
                maxLength={5}
                value={formData[FormInputName.physicalSaleDebit]}
                placeholder="0"
                onChange={e =>
                  onChangeFormInput(FormInputName.physicalSaleDebit)(updateMask(e.target.value))
                }
                error={formErrors.physicalSaleDebit && formErrors.physicalSaleDebit[0]}
                addon="%"
              />
              <InputText
                name="physicalSaleCredit"
                label="Crédito"
                className="w-input-sm"
                maxLength={5}
                value={formData[FormInputName.physicalSaleCredit]}
                placeholder="0"
                onChange={e =>
                  onChangeFormInput(FormInputName.physicalSaleCredit)(updateMask(e.target.value))
                }
                error={formErrors.physicalSaleCredit && formErrors.physicalSaleCredit[0]}
                addon="%"
              />
              <InputText
                name="physicalSalePix"
                label="PIX"
                className="w-input-sm"
                maxLength={5}
                value={formData[FormInputName.physicalSalePix]}
                placeholder="0"
                onChange={e =>
                  onChangeFormInput(FormInputName.physicalSalePix)(updateMask(e.target.value))
                }
                error={formErrors.physicalSalePix && formErrors.physicalSalePix[0]}
                addon="%"
              />
              <InputText
                name="physicalSaleAdministrateTax"
                label="Taxa admin."
                className="w-input-sm"
                maxLength={5}
                value={formData[FormInputName.physicalSaleAdministrateTax]}
                placeholder="0"
                onChange={e =>
                  onChangeFormInput(FormInputName.physicalSaleAdministrateTax)(
                    updateMask(e.target.value),
                  )
                }
                error={
                  formErrors.physicalSaleAdministrateTax &&
                  formErrors.physicalSaleAdministrateTax[0]
                }
                addon="%"
              />
            </FormGroup>
            <div className="d-flex">
              <InstallmentFeesFields
                maxInstallments={24}
                name="physicalSaleInstallmentFees"
                value={formData.physicalSaleInstallmentFees}
                onChange={onChangeFormInput('physicalSaleInstallmentFees')}
                error={formErrors.physicalSaleInstallmentFees?.[0]}
              />
            </div>
          </Col>
        </Row>
      </Form>
    </Fragment>
  );
};
